import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, CheckCircle2, PenLine, Share2 } from "lucide-react";

export const WorkItCard = ({ mod, next, markedDone, onMarkDone, onShare }) => (
  <motion.div
    initial={{ opacity: 0, y: 24 }}
    animate={{ opacity: 1, y: 0 }}
    exit={{ opacity: 0 }}
    transition={{ duration: 0.6, ease: [0.65, 0, 0.35, 1] }}
    className="w-full max-w-2xl bg-white/90 backdrop-blur-md border border-[#F59E0B]/40 shadow-[0_8px_30px_rgba(44,39,32,0.06)] rounded-2xl p-8 md:p-10"
    data-testid="cinematic-workit"
  >
    <div className="flex items-center gap-2 font-mono text-[10px] tracking-[0.3em] uppercase text-[#B45309] mb-4">
      <PenLine size={12} /> Work it — before you leave this page
    </div>
    <p className="font-display text-2xl md:text-3xl leading-snug tracking-tight mb-8">{mod.workIt}</p>
    <div className="flex flex-col sm:flex-row gap-3">
      <button
        onClick={onMarkDone}
        disabled={markedDone}
        data-testid="cinematic-mark-done"
        className={`text-sm justify-center ${markedDone ? "btn-outline pointer-events-none opacity-80" : "btn-ember"}`}
      >
        <CheckCircle2 size={15} /> {markedDone ? "Module marked done" : "Mark this module done"}
      </button>
      {markedDone && (
        <button onClick={onShare} data-testid="cinematic-share" className="btn-ember text-sm justify-center">
          <Share2 size={15} /> Share this milestone
        </button>
      )}
      {next && (
        <Link to={`/modules/${next.id}/experience`} className="btn-outline text-sm justify-center" data-testid="cinematic-next">
          Next: {next.n} · {next.title} <ArrowRight size={15} />
        </Link>
      )}
    </div>
  </motion.div>
);
